export default function() {
	// mobile toggle
	const navToggle: HTMLElement = document.querySelector('[aria-controls="primary-menu"]');
	const nav: HTMLElement = document.querySelector('#primary-menu');
	if (navToggle && nav) {
		nav.setAttribute('aria-hidden', 'true');
		nav.setAttribute('hidden', '');
		navToggle.setAttribute('aria-expanded', 'false');
		navToggle.addEventListener('click', () => {
			navToggle.classList.toggle('is-active');
			nav.classList.toggle('is-active');
			const expanded = navToggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
			navToggle.setAttribute('aria-expanded', expanded);
			const hidden = nav.getAttribute('aria-hidden') === 'true' ? 'false' : 'true';
			nav.setAttribute('aria-hidden', hidden);
		});
	}

	// sub-menu toggle
	const subMenuToggle: NodeListOf<HTMLElement> = document.querySelectorAll('.menu-item-has-children > button');
	if (subMenuToggle) {
		subMenuToggle.forEach((toggle) => {
			toggle.setAttribute('aria-expanded', 'false');
			const subMenu = toggle.nextElementSibling;
			if (subMenu) {
				subMenu.setAttribute('hidden', '');
				subMenu.setAttribute('aria-hidden', 'true');
			}
			toggle.addEventListener('click', () => {
				if (toggle.getAttribute('aria-expanded') === 'true') {
					closeSubMenu();
				} else {
					closeSubMenu();
					openSubMenu(toggle);
				}
			});
		});
	}

	document.addEventListener('click', (event) => {
		const target = event.target as HTMLElement;
		if (!target.closest('.menu-item-has-children')) {
			closeSubMenu();
		}
	});

	function closeSubMenu() {
		const subMenus = document.querySelectorAll('.menu-item-has-children > button');
		subMenus.forEach((toggle) => {
			toggle.setAttribute('aria-expanded', 'false');
			const subMenu = toggle.nextElementSibling;
			if (subMenu) {
				subMenu.setAttribute('hidden', '');
				subMenu.setAttribute('aria-hidden', 'true');
				subMenu.classList.remove('is-active');
			}
		});
	}
	function openSubMenu(toggle: HTMLElement) {
		toggle.setAttribute('aria-expanded', 'true');
		const subMenu = toggle.nextElementSibling;
		if (subMenu) {
			subMenu.removeAttribute('hidden');
			subMenu.setAttribute('aria-hidden', 'false');
			subMenu.classList.add('is-active');
		}
	}
	
}